export default __webpack_public_path__ + "static/media/cx-bio_read_more.b2b50e99.MP4";